import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { IconTrash } from "@tabler/icons-react";
import { deletePillow, fetchPillows } from "../api/pillows";
import DateGroupedGallery from "../components/gallery/DateGroupedGallery";
import GalleryCard from "../components/gallery/GalleryCard";
import { GENERATOR_VIEWS, Page, ViewSwitch } from "../components/ui";

export default function GalleryPillowsPage() {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [total, setTotal] = useState(0);

  return (
    <Page
      title="Gallery"
      description={total > 0 ? `Pillows · ${total}` : "Pillows"}
      actions={<ViewSwitch base="/gallery" options={GENERATOR_VIEWS} />}
    >
      <DateGroupedGallery
        fetchPage={fetchPillows}
        emptyMessage="No pillows yet"
        onTotal={setTotal}
        renderItem={(item, { remove }) => (
          <GalleryCard
            key={item.id}
            src={item.previewUrl ?? item.imageUrl}
            alt={item.id}
            tint={item.previewColor}
            onOpen={() => navigate(`/gallery/pillows/${item.id}`)}
            actions={[
              {
                label: "Delete",
                icon: <IconTrash size={14} />,
                color: "red",
                onClick: () => void deletePillow(instance, item.id).then(() => remove(item.id)),
              },
            ]}
          />
        )}
      />
    </Page>
  );
}
